import { render, staticRenderFns } from "./PressPurchasePrice.vue?vue&type=template&id=4e058fe7&"
import script from "./PressPurchasePrice.vue?vue&type=script&lang=js&"
export * from "./PressPurchasePrice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports